(function () {
  'use strict';

  var BANNER_ID = 'cookie-consent';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initBanner(privacy) {
    var banner = document.getElementById(BANNER_ID);
    if (!banner) return;

    function show() {
      banner.classList.add('is-visible');
      banner.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      banner.classList.remove('is-visible');
      banner.classList.remove('show-prefs');
      banner.setAttribute('aria-hidden', 'true');
    }

    function apply(consent) {
      try {
        if (privacy && typeof privacy.setTrackingConsent === 'function') {
          privacy.setTrackingConsent(consent, function () { hide(); });
          return;
        }
      } catch (e) { /* noop */ }
      hide();
    }

    // Buttons
    banner.querySelectorAll('[data-consent-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        apply({ marketing: true, analytics: true, preferences: true, sale_of_data: true });
      });
    });

    banner.querySelectorAll('[data-consent-reject]').forEach(function (b) {
      b.addEventListener('click', function () {
        apply({ marketing: false, analytics: false, preferences: false, sale_of_data: false });
      });
    });

    banner.querySelectorAll('[data-consent-save]').forEach(function (b) {
      b.addEventListener('click', function () {
        var analytics = !!(banner.querySelector('[data-cat="analytics"]') || {}).checked;
        var marketing = !!(banner.querySelector('[data-cat="marketing"]') || {}).checked;
        var preferences = !!(banner.querySelector('[data-cat="preferences"]') || {}).checked;
        apply({
          marketing: marketing,
          analytics: analytics,
          preferences: preferences,
          sale_of_data: marketing
        });
      });
    });

    banner.querySelectorAll('[data-consent-prefs]').forEach(function (b) {
      b.addEventListener('click', function () {
        banner.classList.toggle('show-prefs');
      });
    });

    // Reopen von ueberall (z.B. Footer Link mit data-open-cookie-settings)
    function openSettings(e) {
      if (e) e.preventDefault();
      var current = null;
      try {
        if (privacy && typeof privacy.currentVisitorConsent === 'function') {
          current = privacy.currentVisitorConsent();
        }
      } catch (err) { /* noop */ }
      if (current) {
        var a = banner.querySelector('[data-cat="analytics"]');
        var m = banner.querySelector('[data-cat="marketing"]');
        var p = banner.querySelector('[data-cat="preferences"]');
        if (a) a.checked = current.analytics === 'yes' || current.analytics === true;
        if (m) m.checked = current.marketing === 'yes' || current.marketing === true;
        if (p) p.checked = current.preferences === 'yes' || current.preferences === true;
      }
      banner.classList.add('show-prefs');
      show();
    }

    window.openCookieSettings = openSettings;
    document.querySelectorAll('[data-open-cookie-settings]').forEach(function (el) {
      el.addEventListener('click', openSettings);
    });

    // Sichtbarkeit entscheiden: nur zeigen, wenn Consent noch aussteht und Region ihn verlangt
    var shouldShow = true;
    try {
      if (privacy && typeof privacy.shouldShowBanner === 'function') {
        shouldShow = privacy.shouldShowBanner();
      } else if (privacy && typeof privacy.currentVisitorConsent === 'function') {
        var c = privacy.currentVisitorConsent();
        shouldShow = !(c && (c.marketing || c.analytics || c.preferences));
      }
    } catch (e) {
      shouldShow = true;
    }

    if (shouldShow) show();
  }

  ready(function () {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          var privacy = (!error && window.Shopify.customerPrivacy) ? window.Shopify.customerPrivacy : null;
          initBanner(privacy);
        }
      );
    } else {
      // Fallback: API nicht verfuegbar, Banner trotzdem anzeigen und dismissbar machen
      initBanner(null);
    }
  });
})();
